import * as React from 'react';
import './DropOffStore.scss';
import RadioButton from 'src/components/common/RadioButton';
import Dropdown from 'src/components/common/Dropdown';
import Button from 'src/components/common/Button';


export const SELF_SHIPPING = 'selfShipping';
export const PURCHASE_PREPAID_SHIPPING = 'purchasePrepaidShipping';


interface IShippingOptionsProps {
  distributionSelectedOption: string;
  handleDistributionChangeOption: (e: any) => void;
  rmaSelected: string;
  storeList:any[];
  isLoading: boolean;
  handleDropOffWarehouse: (e:any)=>void;
  t?: any;
}

const DropOffStore: React.FC<IShippingOptionsProps> = props => {
  const {
    rmaSelected,
    distributionSelectedOption,
    handleDistributionChangeOption,
    storeList,
    isLoading,
    handleDropOffWarehouse,
    t
  } = props;

  const getSelectedOption = () => {
    const options = {
      selfShipping: false,
      purchasePrepaidShipping: false
    };

    options[distributionSelectedOption] = true;
    return options;
  };

  const selection = getSelectedOption();

 



  return (
        <div className="rp-returns-options">
            <div className="rp-returns-options-existing">
              Select Store :
            </div>
            {isLoading ? (
              <div className="rp-returns-options-new">
              <div className="loader-container">
                <div className="loader" />
              </div>
              </div>
            ):(

              <div className="rp-returns-options-new">
            <Dropdown
              options={storeList.map(storeAddr => ({
                label: `${storeAddr.name} - ${storeAddr.addr}`,
                value: storeAddr.code
              }))}
              disabled={null}
              onSelected={handleDropOffWarehouse}
              activeOption={null}
              />
            </div>

            )}
            
         </div>


    
  );
};

export default DropOffStore;
